import { ConversationChannel, MessageType, Participant } from '@vendasta/conversation';
import { ConversationEvent, ConversationMessage } from './interface/conversation.interface';

export type ViewMode = 'modal' | 'sidebar';

export type MessageGroupable = ConversationEvent | ConversationMessage | MessageGroup;

export class MessageGroup {
  readonly id: string;
  readonly type: MessageType;
  readonly channel: ConversationChannel;
  messages: ConversationMessage[];
  readonly sender?: Participant;
  createdAt: Date;

  constructor(
    messageId: string,
    sender?: Participant,
    messageType?: MessageType,
    channel?: ConversationChannel,
    createdAt?: Date,
  ) {
    this.id = `message-group-${messageId}`;
    this.messages = [];
    this.sender = sender;
    this.type = messageType;
    this.channel = channel;
    this.createdAt = createdAt;
  }

  addMessage(message: ConversationMessage): void {
    this.messages.push(message);
  }

  get lastMessage(): ConversationMessage {
    return this.messages?.[this.messages?.length - 1];
  }
}
